// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteSequenceNumberRequestModel from '../../model/delete-sequence-number-request-model';
import DeleteSequenceNumberRequestDTO from '../dto/delete-sequence-number-request-dto';
import dtoSchema from '../schemas/delete-sequence-number-request-schema';

export default abstract class DeleteSequenceNumberRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteSequenceNumberRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteSequenceNumberRequestDTO>): DeleteSequenceNumberRequestModel;
  static toModel(dto: DeepPartial<DeleteSequenceNumberRequestDTO> | undefined | null): DeleteSequenceNumberRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteSequenceNumberRequestDTO> | undefined | null): DeleteSequenceNumberRequestModel | undefined {
    return dto ? new DeleteSequenceNumberRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteSequenceNumberRequestModel> | DeleteSequenceNumberRequestModel): DeleteSequenceNumberRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteSequenceNumberRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteSequenceNumberRequestModel, can not map to DeleteSequenceNumberRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
